import React from 'react';
import PropTypes from 'prop-types';

import { AnalysesIcon } from './index';

import './AnalysesBanner.scss';

const AnalysesBanner = ({ title, analysesList, analysesListIcon }) => {
  return (
    <div className="analyses-banner">
      <div className="container">
        <center>
          <h1>{title}</h1>
        </center>

        <div className="analyses-list">
          {/* analysis icon component */}
          <div className="row">
            {analysesList.map((analyse, i) => {
              return (
                <div key={analyse} className="col">
                  <center>
                    <AnalysesIcon icon={analysesListIcon[i]} title={analyse} />
                  </center>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

AnalysesBanner.propTypes = {
  title: PropTypes.string.isRequired,
  analysesList: PropTypes.array.isRequired,
  analysesListIcon: PropTypes.array.isRequired,
};

export default AnalysesBanner;



// WEBPACK FOOTER //
// ./src/components/Main/services/AnalysesBanner.js